<button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="nav-notification-icons">
  <i class="material-icons-outlined icon-color">{{ triggerIcon }}</i>
  @if (unreadCount > 0) {
    <span class="notification-badge">{{unreadCount}}</span>
  }
</button>

<mat-menu #notificationMenu="matMenu" class="notification-menu">
  <div class="notification-header">
    <h6 class="mb-0">{{ resolvedTitle | translate }}</h6>
    @if (showMarkAll) {
      <a class="notification-mark-as-read" (click)="markAll()">{{ resolvedMarkAllLabel | translate }}</a>
    }
  </div>
  <div class="notification-dropdown">
    <ng-scrollbar style="height: 350px" visibility="hover">
      <div class="noti-list">
        <div class="menu">
          <div>
            @if (notifications.length) {
              @for (notification of notifications; track notification.id || notification.title || notification.message) {
                <button mat-menu-item onClick="return false;"
                  [ngClass]="[notification.status, isRemoving(notification) ? 'notification-removing' : '']"
                  [@notificationAnimation]="isRemoving(notification) ? 'void' : ''"
                  (click)="markAsRead(notification)">
                  <span class="menu-info">
                    <div class="notification-content-row">
                      <span class="table-img msg-user">
                        @if (notification.userImg) {
                          <img [src]="notification.userImg" [alt]="'notifications.userAlt' | translate" class="user-avatar">
                        } @else {
                          <i class="material-icons-outlined notification-type-icon"
                          [ngClass]="[notification.color]">{{notification.icon}}</i>
                        }
                      </span>
                      <div class="notification-copy">
                        @if (notification.title) {
                          <span class="menu-heading">{{notification.title}}</span>
                        }
                        <span class="menu-title">{{notification.message}}</span>
                        <span class="menu-desc">
                          <i class="material-icons">access_time</i> {{notification.time}}
                        </span>
                        @if (notification.actionLabel) {
                          <button mat-stroked-button color="primary"
                            class="notification-action-btn mt-2"
                            (click)="$event.stopPropagation(); onActionClick(notification)">
                            {{notification.actionLabel}}
                          </button>
                        }
                      </div>
                    </div>
                  </span>
                  @if (showClose) {
                    <span class="notification-close"
                      (click)="$event.stopPropagation(); removeNotification(notification)">
                      <app-feather-icons [icon]="'x'" [class]="'user-menu-icons'"></app-feather-icons>
                    </span>
                  }
                </button>
              }
            } @else {
              <div class="notification-empty-state">
                {{ resolvedEmptyLabel | translate }}
              </div>
            }
          </div>
        </div>
      </div>
    </ng-scrollbar>
  </div>
  <div class="notification-footer">
    <a class="notification-read-all" (click)="readAllNotifications()">{{ resolvedFooterLabel | translate }}</a>
  </div>
</mat-menu>
